<div class="user-wrapper">
    <div class="user-view-top-area">
        <h1 *ngIf="user">{{ user.nombre }}</h1>
        <div class="button-area">
            <button type="button" *ngIf="_viewService.editBtn && user" (click)="enableUserForm()" class="edit">
                Editar
            </button>
            <button type="button" *ngIf="_viewService.undoBtn && user" (click)="resetForm()" class="delete">
                Deshacer
            </button>
            <button type="button" *ngIf="_viewService.saveBtn && user" (click)="submit()" class="update">
                Guardar
            </button>
            <button type="button" class="add" [routerLink]="['/users-permits/']" *ngIf="checkPermission('809')">
                Permisos
            </button>
            <button type="button" class="add" (click)="addNewRoles()">Roles</button>
            <button type="button" class="add btn-inform" [matMenuTriggerFor]="submenu">
                Informes
                <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">more_vert</mat-icon>
            </button>
            <button type="button" *ngIf="_viewService.deleteBtn && user" (click)="deleteUser(user.usuarioId)"
                class="delete">
                Eliminar
            </button>

            <mat-menu #submenu="matMenu" [overlapTrigger]="false">
                <a>
                    <button (click)="getControlDeAccesosFile()" mat-menu-item>
                        <span>Control de accesos</span>
                    </button>
                </a>
                <a>
                    <button (click)="getListadoDeUsuariosFileActivos()" mat-menu-item>
                        <span>Listado de usuarios Activos</span>
                    </button>
                </a>
                <a>
                    <button (click)="getListadoDeUsuariosFileInactivos()" mat-menu-item>
                        <span>Listado de usuarios Inactivos</span>
                    </button>
                </a>
            </mat-menu>
        </div>
    </div>
    <div *ngIf="user">
        <div class="user-view-bottom-area" *ngIf="_viewService.hideUserArea">
            <form [formGroup]="userForm">
                <div class="left">
                    <div class="block-looper">
                        <div class="form-wrap-wrp">
                            <div class="form-wrap long-field">
                                <mat-label class="label">Identificador</mat-label>
                                <mat-form-field class="field-form" appearance="fill">
                                    <input type="text" (blur)="
                                        convertToCapital($event, 'abreviacion')
                                    " formControlName="abreviacion" matInput />
                                </mat-form-field>
                                <mat-error class="fix-err" *ngIf="
                                    userForm.get('abreviacion').invalid &&
                                    userForm.get('abreviacion').touched
                                ">
                                    <span *ngIf="
                                        userForm.get('abreviacion').errors
                                            .required
                                    ">
                                        El identificador es obligatorio
                                    </span>
                                </mat-error>
                            </div>
                        </div>
                        <div class="form-wrap-wrp">
                            <div class="form-wrap full-field">
                                <mat-label class="label">Nombre</mat-label>
                                <mat-form-field class="field-form" appearance="fill">
                                    <input type="text" matInput (blur)="convertToCapital($event, 'nombre')"
                                        formControlName="nombre" />
                                </mat-form-field>
                                <mat-error class="fix-err" *ngIf="
                                    userForm.get('nombre').invalid &&
                                    userForm.get('nombre').touched
                                ">
                                    <span *ngIf="
                                        userForm.get('nombre').errors.required
                                    ">
                                        El nombre es obligatorio
                                    </span>
                                </mat-error>
                            </div>
                        </div>
                        <div class="form-wrap-wrp">
                            <div class="form-wrap long-field">
                                <mat-label class="label">Médico</mat-label>
                                <mat-form-field appearance="fill">
                                    
                                    <mat-select placeholder="Seleccione"  panelClass="cus-search-select"  formControlName="medicoId">                                    
                                       <input type="text" autocomplete="off" matInput placeholder="búsqueda" #medicoSelect
                                        (input)="SearchDoctors()" />
                                        <mat-option [value]="null">Ningún médico</mat-option>
                                        <div class="search-options">
                                            <mat-option *ngFor="let doctor of _medicoList" [value]="doctor.value">
                                                {{ doctor.viewValue }}
                                            </mat-option>
                                        </div>                                      
                                    </mat-select>


                                </mat-form-field>
                            </div>
                            <div class="form-wrap long-field">
                                <mat-label class="label">Coordinador</mat-label>
                                <mat-form-field appearance="fill">
                                    <mat-select placeholder="Seleccione" formControlName="coordinador">
                                        <mat-option [value]="null">Ningún coordinador</mat-option>
                                        <mat-option *ngFor="
                                            let coordinator of coordinatorList
                                        " [value]="coordinator.viewValue">
                                            {{ coordinator.viewValue }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="form-wrap-wrp">
                            <div class="form-wrap long-field">
                                <mat-label class="label">Email</mat-label>
                                <mat-form-field class="field-form" appearance="fill">
                                    <input matInput formControlName="email" />
                                </mat-form-field>
                                <mat-error *ngIf="
                                    userForm.get('email').invalid &&
                                    userForm.get('email').touched
                                ">
                                    <span *ngIf="userForm.get('email').errors.pattern">El email es inválido</span>
                                </mat-error>
                            </div>
                            <div class="form-wrap short-field">
                                <mat-label class="label">Teléfono</mat-label>
                                <mat-form-field class="field-form" appearance="fill">
                                    <input matInput type="text" formControlName="telefono" />
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="form-wrap-wrp">
                            <div class="form-wrap short-field">
                                <mat-checkbox class="example-margin" formControlName="verTodosMedicos">Ver todos los
                                    medicos
                                </mat-checkbox>
                            </div>
                            <div class="form-wrap short-field">
                                <mat-checkbox class="example-margin" formControlName="verTodosCoordinadores">Ver todos
                                    los
                                    coordinadores</mat-checkbox>
                            </div>
                            <div class="form-wrap short-field">
                                <mat-checkbox class="example-margin" formControlName="gestor">Gestor
                                </mat-checkbox>
                            </div>
                        </div>
                        <div class="form-wrap-wrp">
                            <div class="form-wrap short-field">
                                <mat-checkbox class="example-margin" formControlName="due">DUE</mat-checkbox>
                            </div>
                        </div>
                        <div class="form-wrap-wrp">
                            <div class="form-wrap long-field">
                                <mat-label class="label">Rol principal</mat-label>
                                <mat-form-field appearance="fill">
                                    <mat-select placeholder="Seleccione" formControlName="rolId">
                                        <mat-option disabled>Seleccione
                                        </mat-option>
                                        <mat-option *ngFor="let role of mainRoleList" [value]="role.value">
                                            {{ role.viewValue }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="form-wrap">
                                <mat-label class="label">Provincia</mat-label>
                                <mat-form-field appearance="fill">
                                    <mat-select formControlName="provincia">
                                        <mat-option value="">Seleccione</mat-option>
                                        <mat-option *ngFor="let province of direccionService.ProvinceList" [value]="province.value">
                                            {{ province.viewValue }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="form-wrap long-field">
                            <mat-label class="label">Grupo de empresa</mat-label>
                            <mat-form-field appearance="fill">
                                <mat-select
                                    formControlName="grupoEmpresaId"
                                    multiple
                                    (selectionChange)="onChangeGrupoEmpresa()"
                                    panelClass="cus-search-select-gempresa">

                                    <input
                                        type="text"
                                        autocomplete="off"
                                        matInput
                                        placeholder="Búsqueda"
                                        #grupoEmpresaSelect
                                        (input)="searchGruposEmpresa()"
                                        (click)="$event.stopPropagation()"
                                        (keydown)="$event.stopPropagation()" />

                                    <mat-option *ngFor="let grupo of filteredGruposEmpresaList"
                                                [value]="grupo.grupoId">
                                        {{ grupo.nombre }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="form-wrap long-field">
                            <mat-label class="label">Observaciones</mat-label>
                            <mat-form-field class="example-full-width" floatLabel="always" appearance="fill">
                                <input matInput formControlName="observaciones" />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </form>
            <div class="mid">
                <div class="wrp">
                    <div id="roles-table" class="roles-table">
                        <h3>
                            Roles adicionales<button [disabled]="!_viewService.buttonDisabled" mat-button
                                (click)="addUserRole()">
                                <mat-icon>add</mat-icon>
                            </button>
                        </h3>
                        <div class="company-table">
                            <table>
                                <caption></caption>
                                <tbody>
                                    <tr *ngFor="let userRole of userRolesList; let i = index">
                                        <td>{{ userRole.rol}}</td>
                                        <td>
                                            <button [disabled]="!_viewService.buttonDisabled" mat-button (click)="
                                              deleteUserRole(userRole.rolId,i)">
                                                <mat-icon>delete_forever</mat-icon>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="right">
                <h3>
                    Grupos de empresa
                    <span *ngIf="gruposEmpresaSeleccionadosNombre">
                        - {{ gruposEmpresaSeleccionadosNombre }}
                    </span>
                </h3>

                <div class="company-table" *ngIf="empresasGrupoSeleccionado?.length; else sinEmpresasGrupo">
                    <table>
                        <tbody>
                            <tr *ngFor="let empresa of empresasGrupoSeleccionado">
                                <td>{{ empresa.nombre }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <ng-template #sinEmpresasGrupo>
                    <div class="selected-group-name" *ngIf="gruposEmpresaSeleccionadosNombre">
                        No hay empresas para los grupos seleccionados.
                    </div>
                </ng-template>
            </div>
            
        </div>
    </div>

</div>